import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
	XCustomTabsFilter,
	XThemeContainer,
} from '../../styles/GlobalThemeStyle';
import HeaderFile from '../../components/Header/HeaderFile';
// import {} from '../Manage/ManageStyle';
//import { XCardsTransparentTabs } from './MAPlansAppealStyling';
import TabPane from 'antd/es/tabs/TabPane';
import {
	Row,
	Col,
	Modal,
	Input,
	Button,
	Result,
	Avatar,
	Tag,
	Grid,
} from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';

// Actions
import { createRoleApi, createRoleReset } from '../../actions/createRoleAction';
import Header from '../../components/Header/Header';
import { checkModulePermissions } from '../../utils/helper';
import StandardAppealTAT from './StandardAppealTAT';
import {
	XTheme2Para1,
	XThemeDashboardLottieCard,
} from '../Dashboard/DashboardStyleCQ';
import DashboardJson from '../../json/Reclaim.json';
import {
	XTheme2Button,
	XTheme2MainTitle,
} from '../../styles/GlobalThemeStyleCQ';
import { PlusOutlined } from '@ant-design/icons';
import { XThemMainTitle } from '../CaseForm/CaseFormStyle';

const Manage = (props) => {
	const navigate = useNavigate();
	const location = useLocation();
	const [maProcessing, setMaProcessing] = useState('ma_standard');
	const [displayOrganization, setDisplayOrganization] = useState(false);
	const [appealLetterApprovals, setAppealLetterApprovals] = useState(0);
	const handleTabChange = (key) => {
		// Update the URL with the filing status
		const queryParams = new URLSearchParams(window.location.search);
		queryParams.set('monitor_type', key);

		if (key == 'appeal_letter_approvals') {
			queryParams.delete('revenue_cycle');
			queryParams.delete('filing_status');
		}

		// Construct the new URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;

		// Push the new URL to the browser history
		window.history.pushState({}, '', newUrl);
		setMaProcessing(key);
		// window.location.reload();
	};

	useEffect(() => {
		if (localStorage.getItem('role') === 'super-admin')
			setDisplayOrganization(true);
	}, []);
	const { useBreakpoint } = Grid;
	const screens = useBreakpoint();
	const isMobile = !screens.md;
	return (
		<>
			<>
				<Col lg={24} xl={24} xs={0} md={0}>
					<Header headerTag="MA Plan Appeals Processing" />
				</Col>
				<Col lg={0} xl={0} xs={24} md={24}>
					<HeaderFile activeNav="userRoleManagement" />
				</Col>
			</>
			<XThemeContainer fluid>
				{/* <XThemMainTitle className="mb-3 d-lg-none">
					MA Plan Appeals Processing
				</XThemMainTitle> */}

				{checkModulePermissions(
					'ma-plan-appeals-processing',
				).sub_modules.includes('list-cases') ? (
					<>
						<Row
							gutter={[15, 15]}
							className="align-items-center mb-4"
						>
							{/* <Col
								xs={24}
								sm={24}
								md={3}
								lg={2}
								className="text-center"
							>
								<XThemeDashboardLottieCard
									className="caseManagementTitleAnimation"
									animationData={DashboardJson}
									loop={true}
								/>
							</Col> */}
							<Col
								xs={24}
								sm={24}
								md={12}
								lg={12}
								xl={12}
								className="text-center text-md-start"
							>
								<XTheme2MainTitle className="mb-2">
									MA Plan Appeals Processing
								</XTheme2MainTitle>
								<XTheme2Para1>
									Monitor and manage MA Plan Appeals
									Processing efficiently
								</XTheme2Para1>
							</Col>
							<Col
								xs={24}
								sm={24}
								md={12}
								lg={12}
								xl={12}
								className="text-center text-md-end"
							>
								{checkModulePermissions(
									'ma-plan-appeals-processing',
								).sub_modules.includes('add-case') ? (
									isMobile ? (
										<XTheme2Button
											shape="circle"
											size="large"
											className="noBackground borderColor"
											onClick={() =>
												navigate('/case/add')
											}
											icon={<PlusOutlined />}
										/>
									) : (
										<Link to="/case/add">
											<XTheme2Button
												size="large"
												icon={<PlusOutlined />}
											>
												Create New Case
											</XTheme2Button>
										</Link>
									)
								) : (
									<></>
								)}
							</Col>
						</Row>

						<XCustomTabsFilter
							// defaultActiveKey="ma_standard"
							type="card"
							activeKey={maProcessing}
							onChange={handleTabChange}
						>
							<TabPane
								key="ma_standard"
								tab="Standard Appeal Turn Around Time"
							>
								<StandardAppealTAT
									maProcessing={maProcessing}
									setMaProcessing={setMaProcessing}
									appealLetterApprovals={
										appealLetterApprovals
									}
									setAppealLetterApprovals={
										setAppealLetterApprovals
									}
								/>
							</TabPane>
							<TabPane
								key="ma_expedited"
								tab="Expedited Appeal Turn Around Time"
							>
								<StandardAppealTAT
									maProcessing={maProcessing}
									setMaProcessing={setMaProcessing}
									appealLetterApprovals={
										appealLetterApprovals
									}
									setAppealLetterApprovals={
										setAppealLetterApprovals
									}
								/>
							</TabPane>
							{checkModulePermissions(
								'appeal-letter',
							).sub_modules.includes('confirm-letter') && (
								<TabPane
									key="appeal_letter_approvals"
									tab={
										<>
											Appeal letter Approvals -{' '}
											<span>{appealLetterApprovals}</span>
										</>
									}
								>
									<StandardAppealTAT
										maProcessing={maProcessing}
										setMaProcessing={setMaProcessing}
										appealLetterApprovals={
											appealLetterApprovals
										}
										setAppealLetterApprovals={
											setAppealLetterApprovals
										}
									/>
								</TabPane>
							)}
						</XCustomTabsFilter>
					</>
				) : (
					<Result
						status="403"
						title="403"
						subTitle="Sorry, you are not authorized to access this page."
						extra={
							<Button
								type="primary"
								onClick={() => navigate('/')}
							>
								Back Home
							</Button>
						}
					/>
				)}
			</XThemeContainer>
		</>
	);
};

const mapStateToProps = (state) => ({
	createRoleState: state.createRole,
});

const mapDispatchToProps = (dispatch) => ({
	createRole: (params) => dispatch(createRoleApi(params)),
	createRoleReset: () => dispatch(createRoleReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Manage);
